import { StyledTableBody, StyledTableCell } from './StylovyzeTable.styles';
import React from 'react';
import { Skeleton } from '@mui/material';
import { TableRow } from '@mui/material';
import { rem } from '@innovyze/stylovyze/lib/utils/styles';
export const StylovyzeTableBodySkeleton = ({ headers, rowsPerPage, rowHeight, rowCount, minHeight, hasButtonItems, }) => {
    return (React.createElement(StyledTableBody, { "$minHeight": minHeight }, new Array(rowsPerPage
        ? parseInt(rowsPerPage.options[rowsPerPage.selectedIndex || 0]
            .name)
        : rowCount)
        .fill(undefined)
        .map((k, i) => (React.createElement(TableRow, { key: `skeleton-row-${i}` },
        headers
            .slice(0, headers.length)
            .map((cell, cellIndex) => (React.createElement(StyledTableCell, { width: headers[cellIndex].width, height: rowHeight, style: {
                maxWidth: headers[cellIndex].maxWidth,
            }, key: `skeleton-${i}-cell-${cellIndex}` },
            React.createElement(Skeleton, { animation: "wave" })))),
        hasButtonItems && (React.createElement(StyledTableCell, { width: rem(48), key: `skeleton-${i}-cell-buttonItems` },
            React.createElement(Skeleton, { animation: "wave" }))))))));
};
